import { mkLogBus, isLogPage } from "@discovery/maestro-tourbus";
import { initDefaults } from "@discovery/maestro-tourbus/lib/impl/defaults";
import { DEVELOPMENT_MODE } from "./env";
import * as M from "@discovery/prelude/lib/data/maybe";
import { AdobeEvents } from "./adobe/events";
import { createAdobeLogListener } from "./adobe";
export const logBus = mkLogBus();
/* Use this to insert log into the bus */
export const log = logBus.log;
const setAdDisplayedStorage = () => {
    try {
        localStorage.setItem("adDisplayed", JSON.stringify(false));
    }
    catch (e) {
        console.info(e);
    }
};
const setEventsStorage = (list) => {
    try {
        localStorage.setItem("events", JSON.stringify(list));
    }
    catch (e) {
        console.info(e);
    }
};
const checkForRoute = (list) => {
    switch (window.location.pathname) {
        case "/terms-of-use":
        case "/privacy-policy":
        case "/contact-us":
        case "/faq":
            return;
        default:
            return setEventsStorage(list);
    }
};
const track = (log) => {
    const route = log.page.url;
    const routeList = [];
    const noOfTriggersBetweenPresentation = Number(localStorage.getItem("noOfTriggersBetweenPresentation"));
    if (isLogPage(log) && log.message === AdobeEvents.PAGE_LOADED) {
        routeList.push(route);
        const localRepoItems = localStorage.getItem("events");
        const newArray = localRepoItems ? JSON.parse(localRepoItems) : [];
        const validTriggers = [
            "",
            "home",
            "collection-view-all",
            "explore",
            "explore-v4",
            "shorts",
            "mindblown",
            "premium",
            "genre",
            "pwa-superstar",
            "l1-genre",
        ];
        let a;
        const validPair = [];
        validTriggers.flatMap((d) => validTriggers.map((v) => {
            if (d !== v) {
                a = { src: d, dest: v };
                validPair.push(a);
            }
            return validPair;
        }));
        let list = [];
        list = routeList.concat(newArray);
        checkForRoute(list);
        const validTriggerPoints = [];
        for (let i = 0; i <= list.length; i++) {
            const subList = list && list.slice(i, i + 2);
            const sample = [{ src: subList[1], dest: subList[0] }];
            if (subList.length === 2 && subList[0] !== subList[1]) {
                sample.map(function (item1) {
                    validPair.map(function (item2) {
                        if (item1.src === item2.src && item1.dest === item2.dest) {
                            validTriggerPoints.push(item1);
                        }
                    });
                });
            }
        }
        let isValid = false;
        isValid =
            validTriggerPoints.length >= noOfTriggersBetweenPresentation
                ? true
                : false;
        try {
            localStorage.setItem("isValidTrigger", JSON.stringify(isValid));
        }
        catch (e) {
            console.info(e);
        }
        let events;
        try {
            events = localStorage.getItem("events");
        }
        catch (e) {
            events = null;
        }
        const neweventList = events ? JSON.parse(events) : [];
        let isAdRendered;
        try {
            isAdRendered = localStorage.getItem("adDisplayed");
        }
        catch (e) {
            isAdRendered = null;
        }
        const popElemnts = isAdRendered && JSON.parse(isAdRendered);
        validTriggerPoints.length >= noOfTriggersBetweenPresentation + 1 &&
            setAdDisplayedStorage();
        if (!popElemnts && neweventList.length > noOfTriggersBetweenPresentation) {
            const list = neweventList.slice(0, 1);
            try {
                localStorage.setItem("events", JSON.stringify(list));
            }
            catch (e) {
                console.info(e);
            }
        }
    }
};
const adsLogListener = {
    transform: (l) => (isLogPage(l) ? M.of(l) : M.empty()),
    log: (l) => track(l),
};
logBus.registerListener(adsLogListener);
initDefaults({
    DEBUG_MODE: DEVELOPMENT_MODE,
}, logBus);
export const provideAdobeUrl = (cache, adobeurl) => {
    return createAdobeLogListener(cache, adobeurl)
        .then(logBus.registerListener)
        .then(() => void 0);
};

